exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scoped-hero-bg[data-v-90b02408] {\n  background: linear-gradient(\n    145deg,\n    rgba(101, 31, 255, 1) 0%,\n    rgba(101, 31, 255, 1) 40%,\n    rgba(255, 71, 120, 1) 100%\n  );\n}\n", ""]);

// exports
